import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBanks } from 'features/banks/actions';
import { getPaymentMethods } from 'features/payment/actions';
import { getServices } from 'features/services/actions';
import { TableWrapper } from 'components/Global';
import ProgressBar from 'components/Global/ProgressBar';
import DetailSewaPage from './DetailSewa';

import { ReactComponent as CarCharterIcon } from 'icons/car-charter-filled-icon.svg';
import { getRentalLocationByServices } from 'features/rental-location/actions';
import { getVehiclesByFilter } from 'features/vehicle/action';
import MetodePembayaranPage from './MetodePembayaran';
import KonfirmasiPesananPage from './KonfirmasiPesanan';
import { getShuttleAirportZone } from 'features/shuttle-airport/actions';
import { getAllAddonByParams } from 'features/addon/actions';
import { getUnavailableDates } from 'features/unavailable-dates/actions';
import { addYears, format } from 'date-fns';

const progressBarPage = [
  {
    id: 'pbp1',
    title: 'Detail Sewa',
  },
  {
    id: 'pbp2',
    title: 'Detail Pembayaran',
  },
  {
    id: 'pbp3',
    title: 'Konfirmasi Pemesanan',
  },
];

const initialState = {
  order_type_id: 8,
  user_name: '',
  phone_number: '',
  wa_number: '',
  phone_country_code: '+62',
  email: '',
  type: '',
  remainder: 0,
  down_payment: 0,
  currency: 'IDR',
  order_detail: {
    vehicle_id: 0,
    is_take_from_rental_office: false,
    end_booking_date: '',
    end_booking_time: '',
    start_booking_date: '',
    start_booking_time: '',
    rental_delivery_location: '',
    rental_delivery_location_detail: '',
    rental_return_location: '',
    rental_return_location_detail: '',
    without_driver: false,
    passenger_number: 0,
    booking_zones: [],
    location_id: 0,
    loc_time_id: '',
    dp_rule_id: 0,
    baggage: 0,
    is_for_other_person: false,
    other_person_name: '',
    other_person_phone: '',
    other_person_email: '',
    other_person_phone_cc: '',
    sub_services_id: 0,
  },
  disbursement: {
    payment_method_id: 0,
    sender_name: '',
    sender_bank_name: '',
    sender_bank_number: '',
    disbursement_confirmation_image: '',
    time_zone: '',
  },
  referral_code: '',
  addons: [],
  fee_meet_greet_board: 0,
};

const CustomOrderCarCharterComponent = () => {
  const dispatch = useDispatch();

  const { data: rentalServicesData } = useSelector((state) => state.services);
  const { data: dataVehicle } = useSelector((state) => state.vehicle);

  const [page, setPage] = useState(1);

  const [allVehicle, setAllVehicle] = useState([]);
  const [vehicleInput, setVehicleInput] = useState('');

  const [orderData, setOrderData] = useState(initialState);
  const [rentalLocation, setRentalLocation] = useState(undefined);
  const [startRentDate, setStartRentDate] = useState('');
  const [selectedCar, setSelectedCar] = useState(undefined);
  const [durationRent, setDurationRent] = useState(0);
  const [luggage, setLuggage] = useState({ luggage: 0, suitcaseXl: 0 });
  const [passengers, setPassengers] = useState({ child: 0, adults: 0 });
  const [selectedAdditionalItem, setSelectedAdditionalItem] = useState(undefined);
  const [ktpImageLink, setKtpImageLink] = useState('');
  const [passportImageLink, setPassportImageLink] = useState('');
  const [selectedPaymentType, setSelectedPaymentType] = useState('');
  const [paymentImageLink, setPaymentImageLink] = useState('');
  const [allRentTime, setAllRentTime] = useState([]);
  const [allAreaCharter, setAllAreaCharter] = useState([]);

  useEffect(() => {
    dispatch(getAllBanks());
    dispatch(getPaymentMethods());
    dispatch(getServices());
  }, []);

  useEffect(() => {
    if (!rentalServicesData.length) return;

    const serviceSewaMobil = rentalServicesData.find((item) => item.name === 'Sewa Mobil');

    const service_id = serviceSewaMobil?.id;
    const sub_service_id = rentalServicesData
      ?.find((item) => item.id === service_id)
      ?.sub_services?.find((item) => item.name === 'Daily')?.id;

    const facility_id = rentalServicesData
      ?.find((item) => item.id === service_id)
      ?.sub_services?.find((item) => item.name === 'Daily')
      ?.facilities?.find((item) => item.name === 'Charter')?.id;

    dispatch(getRentalLocationByServices({ service_id, sub_service_id, facility_id }));
  }, [rentalServicesData]);

  useEffect(() => {
    if (!rentalLocation) return;

    dispatch(
      getUnavailableDates({
        locationId: rentalLocation.id,
        startDate: `${format(new Date(), 'yyyy-MM-dd')} 00:00:00`,
        endDate: `${format(addYears(new Date(), 1), 'yyyy-MM-dd')} 23:59:00`,
        service: 'charter',
      }),
    );

    dispatch(getShuttleAirportZone({ locationId: rentalLocation.id, limit: 100, showSpecialAirportOnly: true }));
  }, [rentalLocation]);

  useEffect(() => {
    if (
      !rentalLocation ||
      !orderData.order_detail.start_booking_date ||
      !orderData.order_detail.end_booking_date ||
      allRentTime?.length === 0 ||
      allRentTime[0]?.booking_start_time === ''
    )
      return;

    const payload = {
      locationRental: rentalLocation.id,
      startTrip: `${orderData.order_detail.start_booking_date} ${allRentTime[0]?.booking_start_time}`,
      endTrip: `${orderData.order_detail.end_booking_date} ${allRentTime[0]?.booking_end_time}`,
      customOrder: true,
      page: 0,
      limit: 0,
      supportCharter: true,
      currency: 'IDR',
    };

    dispatch(getVehiclesByFilter(payload));
  }, [orderData.order_detail.start_booking_date, orderData.order_detail.end_booking_date, allRentTime, rentalLocation]);

  useEffect(() => {
    if (Object.keys(dataVehicle).length === 0) return;
    if (dataVehicle.vehicles === null) {
      setAllVehicle([]);
      return;
    }
    if (dataVehicle?.pagination.page > 1) {
      setAllVehicle((prevState) => [...prevState, ...dataVehicle.vehicles]);
    } else {
      setAllVehicle(dataVehicle.vehicles);
    }
  }, [dataVehicle]);

  useEffect(() => {
    if (
      !rentalLocation ||
      !orderData.order_detail.start_booking_date ||
      !orderData.order_detail.end_booking_date ||
      !allRentTime ||
      allRentTime.length === 0
    )
      return;

    dispatch(
      getAllAddonByParams({
        locationId: rentalLocation?.id,
        locTimeId: rentalLocation?.time_zone_identifier,
        startDate: orderData.order_detail.start_booking_date,
        endDate: orderData.order_detail.end_booking_date,
        startTime: allRentTime[0]?.booking_start_time,
        endTime: allRentTime[allRentTime.length - 1]?.booking_end_time,
      }),
    );
  }, [rentalLocation, orderData.order_detail.start_booking_date, orderData.order_detail.end_booking_date, allRentTime]);

  const prevPage = () => {
    if (page === 1) return;
    setPage((prevState) => prevState - 1);
  };

  const nextPage = () => {
    if (page === progressBarPage.length) return;
    setPage((prevState) => prevState + 1);
  };

  const changeRentalLocationHandler = (location) => {
    setRentalLocation(location);
    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        loc_time_id: location?.time_zone_identifier,
        location_id: location?.id,
      },
    });
  };

  return (
    <div className="custom-order-car-charter">
      <ProgressBar page={page} pageData={progressBarPage} prevPage={prevPage} />

      {/* CONTENT */}
      <TableWrapper
        icon={<CarCharterIcon />}
        title={'Custom Order - Car Charter'}
        className="custom-order-car-charter__form-container"
      >
        {page === 1 ? (
          <DetailSewaPage
            allVehicle={allVehicle}
            vehicleInput={vehicleInput}
            setVehicleInput={setVehicleInput}
            orderData={orderData}
            setOrderData={setOrderData}
            rentalLocation={rentalLocation}
            rentalLocationHandler={changeRentalLocationHandler}
            startRentDate={startRentDate}
            setStartRentDate={setStartRentDate}
            durationRent={durationRent}
            setDurationRent={setDurationRent}
            selectedCar={selectedCar}
            setSelectedCar={setSelectedCar}
            selectedAdditionalItem={selectedAdditionalItem}
            setSelectedAdditionalItem={setSelectedAdditionalItem}
            selectedPaymentType={selectedPaymentType}
            setSelectedPaymentType={setSelectedPaymentType}
            selectedLuggage={luggage}
            selectedPassengers={passengers}
            setSelectedLuggage={setLuggage}
            setSelectedPassengers={setPassengers}
            ktpImageLink={ktpImageLink}
            setKtpImageLink={setKtpImageLink}
            passportImageLink={passportImageLink}
            setPassportImageLink={setPassportImageLink}
            allRentTime={allRentTime}
            setAllRentTime={setAllRentTime}
            allAreaCharter={allAreaCharter}
            setAllAreaCharter={setAllAreaCharter}
            nextPage={nextPage}
            isOrderConfirmation={false}
          />
        ) : page === 2 ? (
          <MetodePembayaranPage
            prevPage={prevPage}
            nextPage={nextPage}
            orderData={orderData}
            setOrderData={setOrderData}
            paymentImageLink={paymentImageLink}
            setPaymentImageLink={setPaymentImageLink}
            isOrderConfirmation={false}
          />
        ) : (
          <KonfirmasiPesananPage
            allVehicle={allVehicle}
            vehicleInput={vehicleInput}
            setVehicleInput={setVehicleInput}
            orderData={orderData}
            setOrderData={setOrderData}
            rentalLocation={rentalLocation}
            rentalLocationHandler={changeRentalLocationHandler}
            startRentDate={startRentDate}
            setStartRentDate={setStartRentDate}
            durationRent={durationRent}
            setDurationRent={setDurationRent}
            selectedCar={selectedCar}
            setSelectedCar={setSelectedCar}
            selectedAdditionalItem={selectedAdditionalItem}
            setSelectedAdditionalItem={setSelectedAdditionalItem}
            selectedPaymentType={selectedPaymentType}
            setSelectedPaymentType={setSelectedPaymentType}
            selectedLuggage={luggage}
            selectedPassengers={passengers}
            setSelectedLuggage={setLuggage}
            setSelectedPassengers={setPassengers}
            ktpImageLink={ktpImageLink}
            setKtpImageLink={setKtpImageLink}
            passportImageLink={passportImageLink}
            setPassportImageLink={setPassportImageLink}
            allRentTime={allRentTime}
            setAllRentTime={setAllRentTime}
            allAreaCharter={allAreaCharter}
            setAllAreaCharter={setAllAreaCharter}
            paymentImageLink={paymentImageLink}
            setPaymentImageLink={setPaymentImageLink}
            nextPage={nextPage}
            prevPage={prevPage}
            isOrderConfirmation={true}
          />
        )}
      </TableWrapper>
    </div>
  );
};

export default CustomOrderCarCharterComponent;
